// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3B6cf","sendOtp":"AuthorizeToLogin_sendOtp__2D26z"};